export default "__VITE_ASSET__DqGOY8fF__"